(function($){

/**
 * ==== FILTROS ===
 */
  class filter{
    constructor( type, el, $, params ){
      this.type = type;
      this.el = el;
      this.untouched = true;
      this.params = params;
      this.$ = $;
      this.init();
    }

    removeUntouched(){
      this.untouched = false;
    }

    init(){
      this.resetErrorMessage();
      this.bindEvents();
    }
    bindEvents(){
      this.$(this.el).on('input', (ev)=>{
        this.untouched = false;
        ev.preventDefault();
        this.validate();
      });
    }
    resetErrorMessage(){
      this.$(this.el).parents("*[data-enroll='form-container']").removeClass("error");
      this.$(this.el).parents("*[data-enroll='form-container']").find("*[data-enroll='error-message']").hide();
      this.$(this.el).parents("*[data-enroll='form-container']").find("*[data-enroll='error-message']").addClass("hidden");
    }
    showError( force ){
      if( this.untouched && !force ) return false;
      this.$(this.el).parents("*[data-enroll='form-container']").addClass("error");
      this.$(this.el).parents("*[data-enroll='form-container']").find("*[data-enroll='error-message']").show();
      this.$(this.el).parents("*[data-enroll='form-container']").find("*[data-enroll='error-message']").removeClass("hidden");
    }
    getValue(){
      return this.$(this.el).val();
    }
  }
  class regexFilter extends filter{
    validate( noCallback ){
      this.resetErrorMessage();
      let value = this.getValue();
      if( !this.pattern.test(value) ){
        this.showError();
        return false;
      }else{
        if( !noCallback ) $(this.el).trigger('validated-ok');
        return true;
      }
    }
  }
  /**
   * Text Filter
   */
  class textFilter extends filter{
    constructor( { el, minSize }, $ ){
      super( 'text', el, $, {
        minSize
      } );
      this.pattern = /^[\p{L}\p{M}\s]+$/u;
    }
    validate( noCallback ){
      this.resetErrorMessage();
      const value = this.$(this.el).val();
      if( this.untouched && value.length < this.params.minSize ){
        return false;
      }else if( value.length < this.params.minSize ){
        this.showError( noCallback );
        return false;
      }else {
        if(!this.pattern.test(value)){
          this.showError( noCallback );
          return false;
        }
        if( !noCallback ) $(this.el).trigger('validated-ok');
        return true;
      }
    }
  }
  class checkedFilter extends filter{
    constructor( { el, minSize }, $ ){
      super( 'text', el, $, {
        minSize
      } );
    }
    validate( noCallback ){
      this.resetErrorMessage();
      if( !$(this.el).prop("checked") ){
        this.showError();
        return false;
      }else{
        if( !noCallback ) $(this.el).trigger('validated-ok');
        return true;
      }
    }
  }
  class passwordFilter extends filter{
    constructor( { el, minSize }, $ ){
      super( 'password', el, $, {
        minSize
      } );
      this.pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};:\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};:\\|,.<>\/?]{6,}$/;
    }
    validate( noCallback ){
      this.resetErrorMessage();
      const value = this.$(this.el).val();
      if(!this.pattern.test(value)){
        this.showError();
        return false;
      }
      if( !noCallback ) $(this.el).trigger('validated-ok');
      return true;
    }
  }
  class emailFilter extends regexFilter{
    constructor( { el, minSize }, $ ){
      super( 'email', el, $, {
        minSize
      } );
      this.pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    }
  }
  class dateOfBirthFilter extends regexFilter{
    constructor( { el, minSize }, $ ){
      super( 'dateOfBirth', el, $, {
        minSize
      } );
      this.pattern = /^\d{4}-\d{2}-\d{2}$/;
    }
  }
  class phoneFilter extends regexFilter{
    constructor( { el, minSize }, $ ){
      super( 'phone', el, $, {
        minSize
      } );
      this.pattern = new RegExp("^\\d{"+ this.params.minSize + "}$");
    }
    getValue(){
      const rawValue = this.$(this.el).val();
      const value = rawValue.replace(/[^0-9]/g, "");
      return value;
    }
  }

/**
 * === FORMULARIOS ===
 */
  class formController{

    filteredFields = [];
    endPoint = "https://minipipila-mx-d2c.frontend.dev.us-east-1.starterkit.rbcloud.io";
    shop = "enfamil-mexico-dev2.myshopify.com";
    signSecretKey = "St.B2N2y24cMoG.FEYDMItDn16NSwOiT1KqHtPqFvTATAONv";
    routes = {
      credentials: "/oauth/client-credentials",
      token: "/oauth/auth",
      login: "/oauth/login",
      refreshToken: "/oauth/token",
      register: "/cdp/register",
      view: "/cdp/get",
      update: "/cdp/update",
      passwordRecovery: {
        request: "/oauth/request-password-recovery",
        validate: "/oauth/validate-recovery-token",
        update: "/oauth/reset-password"
      },
    }
    untouched = true;

    constructor(el,$){
      el.__controller=this;
      this.el = el;
      this.$ = $;
    }

    init() {
      $(this.el).submit((ev)=>{
        ev.preventDefault();
        ev.stopPropagation();
      });
      this.createFilters();
      this.bindSubmit();
      this.validate();
    }

    removeUntouched(){
      this.filteredFields.forEach( filter => {
        filter.removeUntouched();
      });
    }

    onInvalid(){
      $(this.el).find("*[data-enroll='submit-button']").attr("disabled",false);
      $(this.el).find("*[data-enroll='submit-button']").prop("disabled",false);
    }

    onValid(){
      $(this.el).find("*[data-enroll='submit-button']").attr("disabled",true);
      $(this.el).find("*[data-enroll='submit-button']").attr("prop",true);
    }

    validate( exception ){
      let valid = true;
      $(this.el).find("*[data-enroll='submit-button']").attr("disabled",false);
      $(this.el).find("*[data-enroll='submit-button']").prop("disabled",false);
      this.filteredFields.forEach( filter => {
        if( $(exception).attr("name") != $(filter.el).attr("name") && !filter.validate( true ) ){
          $(this.el).find("*[data-enroll='submit-button']").attr("disabled",true);
          $(this.el).find("*[data-enroll='submit-button']").attr("prop",true);
          valid = false;
        }
      } );
      return valid
    }

    request( endPoint, payload ){
      return new Promise((resolve, reject) => {
        fetch( endPoint , payload).then(
          response => {
            if (!response.ok) {
              try {
                response.json().then(
                  data => reject(data),
                  error => reject(response)
                );
              } catch ( e ){
                return reject(e);
              }
            } else {
              try {
                response.json().then(
                  data => resolve(data),
                  error => reject(response)
                );
              } catch ( e ){
                return reject(e);
              }
            }
          }
        );
      });
    }

    submit( noRetry ){
      const payload = this.getPayload();
      
      this.getToken().then(
        token =>{
          const currentMinute = new Date().getMinutes();
          const cryptData = this.encrypt(payload, token.access_token, currentMinute);
          const idx = uuid.v4();
          const txPayload = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token.access_token}`
            },
            body: JSON.stringify({
              idx,
              data: btoa(cryptData)
            })
          };
          this.request( `${this.endPoint}${this.route}`, txPayload ).then(
            response => {
              if(!response){
                handleErrorCode( response );
                return console.error('💔 no response', response);
              }
              if( response.idx != idx || !response.message ){
                handleErrorCode( response );
                return console.error('🍝 unknow idx', response);
              }
              if( response.message.access_token ){
                this.saveLocalToken( response.message );
              }
              return this.onSubmit( response );
            }, error => {
              switch( error.errorCode ){
                case 10:
                  this.deleteToken();
                  if( !noRetry ){
                    this.submit( true );
                  } else {
                    handleErrorCode( error );
                  }
                  break;
                default:
                  handleErrorCode( error );
                  break;
              }
            }
          );
        }, e => {
          console.error(e);
        }
      );
    }

    deleteToken(){
      return new Promise( (resolve, reject) => {
        localStorage.removeItem('__d2ctCC');
        resolve();
      } );
    }

    getToken() {
      return new Promise((resolve, reject) => {
        let token = false;
        try {
            token = this.getlocalToken();
          } catch(e){
          }
        if (token && (token.expirationDate) > (new Date()).getTime()) {
          return resolve(token);
        } else if (token) {
          return this.getRefreshToken(token).then(resolve, reject);
        } else {
          return this.getRemoteToken().then(resolve, reject);
        }
      });
    }

    getlocalToken(){
      const cryptedToken = localStorage.getItem("__d2ctCC");
      try {
        if(cryptedToken){
          const decriptedToken = this.decrypt(cryptedToken, this.signSecretKey, 'abcde123');
          if(decriptedToken){
            const token = JSON.parse(decriptedToken);
            return token;
          }
        }
      } catch(e){
        return null;
      }
      return null;
    }

    saveLocalToken( token ){
      const now = new Date();
      const now2 = new Date();
      const s1 = now.getSeconds() + token.expires_in;
      const s2 = now.getSeconds() + token.refresh_expires_in;
      now.setSeconds(s1);
      now2.setSeconds(s2);
      token.expirationDate = now.getTime();
      token.refreshExpirationDate = now2.getTime();
      const payload = btoa(JSON.stringify(token));
      const cryptedToken = this.encrypt(payload, this.signSecretKey, 'abcde123' );
      localStorage.setItem("__d2ctCC", cryptedToken);
      return token;
    }

    encrypt( payload , salt, secret ){
      const key = CryptoJS.MD5(`${ salt }/${ this.signSecretKey }/A87590BDBEA3A8ED4B5A6E5A98396E5C/${ secret }`).toString();
      const base64payload = btoa(JSON.stringify(payload));
      const cryptData = CryptoJS.AES.encrypt(base64payload, key).toString();
      return cryptData;
    }

    decrypt( cryptData , salt, secret ){
      const key = CryptoJS.MD5(`${ salt }/${ this.signSecretKey }/A87590BDBEA3A8ED4B5A6E5A98396E5C/${ secret }`).toString();
      const base64payload = CryptoJS.AES.decrypt(cryptData,key).toString(CryptoJS.enc.Utf8);
      const payload = JSON.parse(atob(base64payload));
      return atob(payload);
    }

    getRefreshToken ({ refresh_token }) {
      return new Promise((resolve, reject) => {
        fetch(`${this.endPoint}${this.routes.refreshToken}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${refresh_token}`
          }
        }).then(
          response => {
            if (!response.ok) {
              return this.getRemoteToken().then(resolve, reject);
            } else {
              return response.json();
            }
          }
        ).then(
          token => {
            if (!token) {
              return this.getRemoteToken().then(resolve, reject);
            }
            if (token.refreshExpirationDate / 1000 < (new Date()).getTime()) {
              return this.getRemoteToken().then(resolve, reject);
            }
            resolve(this.saveLocalToken(token));
          }, reject
        );
      });
    }

    getRemoteToken(){
      return new Promise((resolve, reject) => {
        this.getCredentials().then(
          ({ client_id, client_secret }) => {
            fetch(`${this.endPoint}${this.routes.token}`, {
              method: 'GET',
              headers: {
                'Authorization': `Basic ${btoa(client_id + ":" + client_secret)}`
              }
            }).then(
              response => {
                const responseJson = response.json();
                if (!response.ok){
                  responseJson.then( data => handleErrorCode( data )); 
                  return reject(response);
                }
    
                return responseJson;
              }
            ).then(
              token => {
                resolve(this.saveLocalToken(token));
              }, reject
            );
          }, reject
        );
      })
    }

    getCredentials() {
      return new Promise((resolve, reject) => {
        fetch(`${this.endPoint}${this.routes.credentials}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "shop": this.shop
          })
        }).then(
          response => {
            if (!response.ok){
              const setError = response.json();
              setError.then( data => handleErrorCode( data )); 
              return reject(response);
            } 
    
            return response.json();
          }
        ).then(
          data => {
            resolve(data)
          }, reject
        );
      });
    }

    bindSubmit(){
      $(this.el).find("*[data-enroll='submit-button']").on('click', (ev)=>{
        ev.preventDefault();
        ev.stopPropagation();
        this.removeUntouched();
        if( this.validate() ){
          this.submit();
        }
      });
      $(this.el).on('submit', (ev)=>{
        ev.preventDefault();
        ev.stopPropagation();
        this.removeUntouched();
        if( this.validate() ){
          this.submit();
        }
      });
    }

    createFilters( el ){
      el = el ? el : this.el;
      this.$(el).find("*[data-filtered='1']").each( ( i, field ) => {
        const filter = this.getFilter( field, $( field ).data('filter').split('|') );
        this.filteredFields.push(filter);
        $( field ).on('validated-ok',()=>{ 
            this.validate(field) 
          })
        $( field ).on('deleted',()=>{
            const j = this.filteredFields.indexOf(filter);
            if( j > -1 ) this.filteredFields.splice(j, 1);
          })
      });
    }

    getFilter( el, [ type, minSize ]){
      switch ( type ) {
        case 'text':
          return new textFilter( { el, minSize }, this.$ );
          break;
        case 'email':
          return new emailFilter( { el, minSize }, this.$ );
          break;
        case 'dateOfBirth':
          return new dateOfBirthFilter( { el, minSize }, this.$ );
          break;
        case 'phone':
          return new phoneFilter( { el, minSize }, this.$ );
          break;
        case 'password':
          return new passwordFilter( { el, minSize }, this.$ );
          break;
        case 'checked':
          return new checkedFilter( { el, minSize }, this.$ );
          break;
        default:
          console.error('🍍Unknow filter type', type);
      }
    }

  }
  class registerFormController extends formController{

    route = this.routes.register;
    
    constructor(el,$){
      super(el,$);
      this.init();
    }

    onSubmit(response){
      this.untouched = false;
      if( response.message && response.message.status == 'ok' && response.message.login_url ){
        window.location.href = response.message.login_url;
      } else {
        console.error('🥨Error desconocido', response);
      }
    }

    getPayload(){
      const formData = {};
      $(this.el).find("*[data-enroll='field']").each( (i, field) => {
        formData[$(field).attr("name")] = $(field).val();
      } );

      const payload = {
        "FirstName": formData.fname,
        "LastName": formData.lname,
        "Email": formData.email,
        "JoinDate": ((new Date()).getTime() / 1000).toString(),
        "ActivityDate": ((new Date()).getTime() / 1000).toString(),
        "EnrollChannelCode": 'WEB',
        "tzOffset": (new Date()).getTimezoneOffset() / 60,
        "Password": formData.password,
        "AcceptMarketing": formData.CustomerFormoptin == 'on',
      }

      if(formData.dob){
        payload.JsonExternalData = payload.JsonExternalData ? payload.JsonExternalData : {};
        payload.JsonExternalData.Children = payload.JsonExternalData.Children ? payload.JsonExternalData.Children : [];
        const childData = {};
        childData.BirthDate = (Date.parse(formData.dob) / 1000).toString();
        payload.JsonExternalData.Children.push( childData );
      }

      if (formData.pediatricianame) {
        payload.pediatricianName = formData.pediatricianame;
      }

      if (formData.phone) {
        payload.Phones = [{ 
          PhoneNumber: formData.phone.replace(/[^0-9]/g, "") ,
          Status: "A",
          IsPreferred: true,
          PhoneCountryCode: "MEX",
          DeliveryStatus: "G",
        }];
      }

      const optIns = {
        "CustomerFormoptin": {
          SubscriptionId: "d19272db-0db6-4129-87bb-f4fc89dda375",
          OptSource: "WEB",
          ChannelCode: "EM",
          OptStatus: formData.CustomerFormoptin == 'on'
        },
        "CustomerFormoptin": {
          SubscriptionId: "d19272db-0db6-4129-87bb-f4fc89dda375",
          OptSource: "WEB",
          ChannelCode: "EM",
          OptStatus: formData.CustomerFormoptin == 'on'
        },
      };

      const optins = Object.values(optIns);
      optins.map(({
        OptSource,
        ChannelCode,
        OptStatus,
        SubscriptionId
      }) => {
        if (!payload.optins) {
          payload.optins = [];
        }
        payload.optins.push({
          OptSource,
          ChannelCode,
          SubscriptionId,
          OptStatus,
          ActivityDate: ((new Date()).getTime() / 1000).toString(),
          Status: "A",
          JsonExternalData: {
            ContactPointValue: payload.Email,
            EmailOptFlag: OptStatus ? "Y" : "N"
          }
        });
      });
  

      return payload;
    }
  }
  class loginFormController extends formController{

    route = this.routes.login;
    constructor(el, $){
      super(el, $);
      this.init();
      this.deleteToken();
    }

    onSubmit(response){
      if( response.message && response.message.status == 'ok' && response.message.login_url ){
        window.location.href = response.message.login_url;
      } else {
        console.error('🥨Error desconocido', response);
      }
    }

    getPayload(){
      const formData = {};
      $(this.el).find("*[data-enroll='field']").each( (i, field) => {
        formData[$(field).attr("name")] = $(field).val();
      } );

      const payload = {
        "Email": formData.email,
        "Password": formData.password,
        shop: this.shop
      }
      return payload;
    }
  }

  class resetPasswordFormController extends formController{

    route = this.routes.passwordRecovery.request;
    constructor(el, $){
      super(el, $);
      this.init();
    }

    onSubmit(response){
      if( response.message && response.message.status == 'ok' && response.message.login_url ){
        this.showModal();
      } else {
        console.error('���Error desconocido', response);
      }
    }

    showModal(){
      $(this.el).find("*[data-enroll='modal']").modal('show');
    }

    getPayload(){
      const formData = {};
      $(this.el).find("*[data-enroll='field']").each( (i, field) => {
        formData[$(field).attr("name")] = $(field).val();
      } );

      const payload = {
        "Email": formData.email,
        shop: this.shop
      }
      return payload;
    }
  }

  class changePasswordFormController extends formController{
    route = this.routes.passwordRecovery.update;
    constructor(el, $){
      super(el, $);
      this.init();
      this.validateQueryToken().then(
        ()=>{},(error)=>{
          window.location.href = "/";
        }
      );
    }

    getQueryToken(){
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('token');
    }

    validateQueryToken(){
      return new Promise((resolve, reject) => {
        const token = this.getQueryToken();
        if( !token ){
          return reject('Token not found');
        }
        fetch(`${this.endPoint}${this.routes.passwordRecovery.validate}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }).then(
          response => {
            if (!response.ok){
              const setError = response.json();
              setError.then( data => handleErrorCode( data ));
              return reject(response);
            }
            return response.json();
          }
        ).then(
          data => {
            resolve(data);
          }, reject
        );
      });
    }
    getToken(){
      return new Promise((resolve, reject) => {
        const token = this.getQueryToken();
        if( !token ){
          return reject('Token not found');
        }
        resolve({
          access_token: token
        });
      });
    }
    getPayload(){
      const formData = {};
      $(this.el).find("*[data-enroll='field']").each( (i, field) => {
        formData[$(field).attr("name")] = $(field).val();
      } );

      const payload = {
        "Password": formData.password,
        "ConfirmPassword": formData.confirmPassword
      }
      return payload;
    }
    onSubmit(response){
      if( response.message && response.message.status == 'ok' ){
        window.location.href = "/";
      } else {
        console.error('���Error desconocido', response);
      }
    }
  }

  class updateFormController extends formController{

    route = this.routes.login;
    constructor(el, $){
      super(el, $);
      this.init();
    }

    onSubmit(response){
      console.error('🥨Error desconocido', response);
    }

    getPayload(){
      const formData = {};
      $(this.el).find("*[data-enroll='field']").each( (i, field) => {
        formData[$(field).attr("name")] = $(field).val();
      } );

      const payload = {
        "Email": formData.email,
        shop: this.shop
      }
      return payload;
    }
  }

  class viewController extends formController{
    lockFields(){
      $(this.el).find("*[data-enroll='field']").each( (i, field) => {
        $(field).prop('readonly', true);
        if($(field).attr('type') == "checkbox") {
          $(field).prop('disabled', true);
        }
      } );
      $(this.el).find("select[data-enroll='field']").each( (i, field) => {
        $(field).prop('disabled', true);
      } );
      $(this.el).find("*[data-hide-on-view='1']").hide();
      $(this.el).find("*[data-hide-on-edit='1']").show();
    }
    unlockFields(){
      $(this.el).find("*[data-enroll='field']").each( (i, field) => {
        if($(field).attr('data-hardlock') != '1'){
          $(field).prop('readonly', false);
          if($(field).attr('type') == "checkbox") {
            $(field).prop('disabled', false);
          }
        }
      } );
      $(this.el).find("select[data-enroll='field']").each( (i, field) => {
        $(field).prop('disabled', false);
      } );
      $(this.el).find("*[data-hide-on-view='1']").show();
      $(this.el).find("*[data-hide-on-edit='1']").hide();
    }
  }


  class viewProfileController extends viewController{

    route = this.routes.login;
    editStatus = false;

    constructor(el, $){
      super(el, $);
      this.init();
      this.lockFields();
      this.bindButtons();
      this.loadCustomerData();
    }

    bindButtons(){
      $(this.el).find("*[data-enroll='edit']").on('click', (ev)=>{
        this.unlockFields();
      });
      $(this.el).find("*[data-enroll='cancel-edit']").on('click', (ev)=>{
        this.lockFields();
        window.location.reload();
      });
      $(this.el).find("*[data-enroll='save-edit']").on('click', (ev)=>{
        this.save();
      });
      $(this.el).find("*[data-enroll='addChild']").on('click', (ev)=>{
        this.addChild();
      });
    }



    addOptin( optin ){
      const container = $(this.el).find("tbody[data-enroll='optinContainer']");
      const template = $(container.find("template[data-enroll='optinTemplate']").prop("content")).find("tr");
      const row = template.clone(true);
      if ( optin ){
        $(row).prop("optinData", optin );
        $(row).find("input[name='optin[]']").prop( "checked", optin.OptStatus );
        $(row).find("input[name='optin[]']").attr( "id", `optin_${optin.SubscriptionId}` );
        $(row).find("label").attr( "for", `optin_${optin.SubscriptionId}` );
      }
      $(container).append(row);
    }

    addChild( child ){
      const container = $(this.el).find("tbody[data-enroll='childrenContainer']");
      const template = $(container.find("template[data-enroll='childrenTemplate']").prop("content")).find("tr");
      const row = template.clone(true);

      if ( child ){
        const bDate = new Date(child.BirthDate);
        $(row).find("input[name='FirstName']").val( child.FirstName );
        $(row).find("select[name='GenderCode']").val( child.GenderCode??"U" );
        $(row).find("input[name='BirthDate']").val( bDate.toISOString().split("T",2)[0] );
        $(row).prop("childrenData", child );
      } else {
        $(row).addClass("new");
      }

      $(row).find("input[name='FirstName']").attr( 'name', 'FirstName[]' );
      $(row).find("select[name='GenderCode']").attr( 'name', 'GenderCode[]' );
      $(row).find("input[name='BirthDate']").attr( 'name', 'BirthDate[]' );
      $(container).append(row);
      this.bindChildButtons(row);
    }

    removeChild( row ){
      $(row).find("*[data-enroll='field']").trigger('deleted');
      $(row).remove();
    }

    bindChildButtons( row ){
      $(row).find("*[data-enroll='removeChild']").on('click', (ev)=>{
        this.removeChild(row);
      });
      this.createFilters( row );
    }

    save(){
      this.removeUntouched();
      if( ! this.validate() ){
        console.error('Fallo en la validación')
        return false;
      }
      this.lockFields();
      this.getToken().then(
        token => {
          const payload = this.getPayload();
          const currentMinute = new Date().getMinutes();
          const key = CryptoJS.MD5(`${token.access_token}/${this.signSecretKey}/A87590BDBEA3A8ED4B5A6E5A98396E5C/${currentMinute}`).toString();
          const base64payload = btoa(JSON.stringify(payload))
          const cryptData = CryptoJS.AES.encrypt(base64payload, key).toString();
          const idx = uuid.v4();

          fetch(`${this.endPoint}${this.routes.update}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token.access_token}`
            },
            body: JSON.stringify({
              idx,
              data: btoa(cryptData)
            })
          }).then(
            response => {
              if (!response.ok) {
                const setError = response.json();
                setError.then( data => handleErrorCode( data )); 
                return this.onSubmit(response);
              }

              return response.json();
            }
          ).then(
            response => {
              if( response.user ){
                this.populateFields(response.user);
                this.lockFields();
              }
            }
          );
        }, e => {
          console.error(e);
        }
      );
    }

    getPayload(){
      const formData = {};
      const childContainer = $(this.el).find("*[data-enroll='childrenContainer']");
      const optinContainer = $(this.el).find("*[data-enroll='optinContainer']");
      $(this.el).find("*[data-enroll='field']").each( (i, field) => {
        formData[$(field).attr("name")] = $(field).val();
      } );

      const payload = {
        "FirstName": formData.fname,
        "LastName": formData.lname,
        "Email": formData.email,
        "ActivityDate": ((new Date()).getTime() / 1000).toString(),
        "EnrollChannelCode": 'WEB',
        "tzOffset": (new Date()).getTimezoneOffset() / 60,
      }

      if (formData.pediatricianame) {
        payload.pediatricianName = formData.pediatricianame;
      }  

      if (formData.phone) {
        payload.Phones = [{ 
          PhoneId:  $(this.el).find("*[name='phone']").attr("data-phone-id"),
          PhoneNumber: formData.phone.replace(/[^0-9]/g, "") ,
          Status: "A",
          IsPreferred: true,
          PhoneCountryCode: "MEX",
          DeliveryStatus: "G",
        }];
      }  

      if(childContainer){
        payload.JsonExternalData = payload.JsonExternalData ? payload.JsonExternalData : {};
        payload.JsonExternalData.Children = payload.JsonExternalData.Children ? payload.JsonExternalData.Children : [];
        $( childContainer ).find("*[data-enroll='children']").each( ( i, childRow ) => {
          const childData = $(childRow).prop("childrenData") ? $(childRow).prop("childrenData") : {};
          childData.FirstName = $(childRow).find("input[name='FirstName[]']").val(),
          childData.GenderCode = $(childRow).find("select[name='GenderCode[]']").val(),
          childData.BirthDate = (Date.parse($(childRow).find("input[name='BirthDate[]']").val()) / 1000).toString(),
          payload.JsonExternalData.Children.push( childData );
        });

      }

      if(optinContainer){
        payload.JsonExternalData = payload.JsonExternalData ? payload.JsonExternalData : {};
        payload.JsonExternalData.ProfileSubscriptions = payload.JsonExternalData.ProfileSubscriptions ? payload.JsonExternalData.ProfileSubscriptions : [];
        $( optinContainer ).find("*[data-enroll='optin']").each( ( i, optinRow ) => {
          const optinData = $(optinRow).prop("optinData") ? $(optinRow).prop("optinData") : {};
          optinData.OptStatus = $(optinRow).find("input[name='optin[]']").prop("checked") ? true : false,
          optinData.Status = $(optinRow).find("input[name='optin[]']").prop("checked") ? "A" : "I",
          payload.JsonExternalData.ProfileSubscriptions.push( optinData );
        });

      }
      return payload;
    }

    populateFields( user ){
      $(this.el).find("*[name='fname']").val(user.FirstName);
      $(this.el).find("*[name='lname']").val(user.LastName);
      $(this.el).find("*[name='email']").val(user.Email);
      $(this.el).find("*[name='pediatricianame']").val(user.pediatricianName);
      if(user.Phones && user.Phones.length > 0){
        $(this.el).find("*[name='phone']").val(user.Phones[0].PhoneNumber);
        $(this.el).find("*[name='phone']").attr("data-phone-id",user.Phones[0].PhoneId);
      }

      if(user.JsonExternalData && user.JsonExternalData.Children && user.JsonExternalData.Children.length > 0 ){
        user.JsonExternalData?.Children?.map( (child) => {
          this.addChild( child );
        });

      }

      if(user.JsonExternalData && user.JsonExternalData.ProfileSubscriptions && user.JsonExternalData.ProfileSubscriptions.length > 0 ){
        user.JsonExternalData?.ProfileSubscriptions?.map( (optin) => {
          this.addOptin( optin );
        });

      }

      this.lockFields();
    }

    loadCustomerData(){
      this.getToken().then(
        token => {
          fetch(`${this.endPoint}${this.routes.view}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token.access_token}`
            }
          }).then(
            response => {
              if (!response.ok){
                const setError = response.json();
                setError.then( data => handleErrorCode( data )); 
                return this.onError(response);
              } 

              return response.json();
            }
          ).then(
            response => {
              if( response && response.user ){
                this.populateFields(response.user);
              }
            }
          );
        }, e => {
          console.error(e);
        }
      );
    }

    onError(response){
      switch( response.status ){
        case 403:
          console.error('���Token invalido');
          this.deleteToken().then(
            () => {
              window.location = "/account/logout";
            }
          );
          break;
        default:
          console.error('🥨Error desconocido', response);
      }
    }
  }

  class logoutController extends formController{
    constructor(el, $){
      super(el, $);
      this.init();
    }
    init(){
      this.bindButtons();
    }
    bindButtons(){
      $(this.el).on('click', (ev)=>{
        this.logout();
      });
    }
    logout(){
      this.deleteToken();
      window.location = "/account/logout";
    }
  }



  $.fn.pipila = function(options){
    $(this.each(function(){
      $(this).find("form[data-pipila='register']").each( function(){
        const formController = new registerFormController(this, $);
      } );
      $(this).find("form[data-pipila='login']").each( function(){
        const formController = new loginFormController(this, $);
      } );
      $(this).find("form[data-pipila='update']").each( function(){
        const formController = new updateFormController(this, $);
      } );
      $(this).find("*[data-pipila='view']").each( function(){
        const formController = new viewProfileController(this, $);
      } );
      $(this).find("*[data-pipila='logout']").each( function(){
        const formController = new logoutController(this, $);
      } );
      $(this).find("*[data-pipila='forgotPassword']").each( function(){
        const formController = new resetPasswordFormController(this, $);
      } );
      $(this).find("*[data-pipila='changePassword']").each( function(){
        const formController = new changePasswordFormController(this, $);
      } );
    }))
  }
})( jQuery );

$(document).ready( function () {
  $(document).pipila();
});